export const POST_MESSAGE_PROTOCOL = "rewardPlugin:v1";

interface BasePostMessage {
  protocol: typeof POST_MESSAGE_PROTOCOL;
  type: PostMessageType;
}

export enum PostMessageType {
  DISPLAY_CLOSE_BUTTON = "DISPLAY_CLOSE_BUTTON",
}

export type PostMessage = BasePostMessage & {
  type: PostMessageType.DISPLAY_CLOSE_BUTTON;
  display: boolean;
};

export type PostMessageData = Omit<PostMessage, "protocol">;

export const postMessageData = (
  data: PostMessageData,
  target: Window = window.parent,
): void => {
  const message: PostMessage = {
    protocol: POST_MESSAGE_PROTOCOL,
    ...data,
  };

  target?.postMessage(message);
};

export const parseMessageEvent = (event: MessageEvent): PostMessage | null => {
  if (
    !event.data ||
    !("protocol" in event.data) ||
    (event.data as PostMessage).protocol !== POST_MESSAGE_PROTOCOL
  ) {
    return null;
  }

  return event.data as PostMessage;
};
